import(/* webpackMode: "eager" */ "/app/apps/frontend/node_modules/next/dist/client/app-dir/link.js");
